// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 视频播放器样式 */

.video-player {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: var(--gray-900);
  min-height: 300px;
  animation: fadeIn var(--duration-normal) ease;
}

.video-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), transparent);
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  opacity: 0;
  transition: opacity var(--duration-normal) ease;
}

.video-header.visible {
  opacity: 1;
}

.video-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
}

.video-title i {
  color: var(--lemon-400);
}

.video-controls {
  display: flex;
  gap: 0.5rem;
}

.control-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--duration-normal) ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.control-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.control-btn.active {
  background: var(--lemon-400);
  color: var(--gray-900);
}

.connection-details {
  position: absolute;
  top: 60px;
  right: 1rem;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 1rem;
  min-width: 250px;
  z-index: 15;
  animation: slideInDown var(--duration-normal) ease;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.detail-row:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.detail-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.detail-label i {
  color: var(--lemon-400);
  width: 14px;
}

.detail-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
}

.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status-indicator.success {
  background: rgba(34, 197, 94, 0.2);
  color: var(--leaf-400);
}

.status-indicator.warning {
  background: rgba(250, 204, 21, 0.2);
  color: var(--lemon-400);
}

.status-indicator.error {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.video-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: var(--gray-900);
  min-height: 300px;
}

.video-overlay {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 10;
}

.streaming-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(34, 197, 94, 0.9);
  color: white;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.streaming-indicator i {
  font-size: 0.625rem;
  color: white;
}

.video-stats {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 1rem;
  backdrop-filter: blur(10px);
  border-radius: 0 0 16px 16px;
  opacity: 0;
  transition: opacity var(--duration-normal) ease;
}

.video-player:hover .video-stats {
  opacity: 1;
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 0.75rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: center;
}

.stat-label {
  font-size: 0.625rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
  margin-bottom: 0.125rem;
}

.stat-value {
  font-size: 0.8125rem;
  font-weight: 600;
  color: white;
  word-break: break-word;
}

.stat-value.good {
  color: var(--leaf-400);
}

.stat-value.warning {
  color: var(--lemon-400);
}

.stat-value.error {
  color: #ef4444;
}

.local-player {
  border: 2px solid var(--leaf-400);
  box-shadow: 0 0 20px rgba(34, 197, 94, 0.3);
}

.remote-player {
  border: 2px solid var(--lemon-400);
  box-shadow: 0 0 20px rgba(250, 204, 21, 0.3);
}

.pulse {
  animation: pulse 2s infinite;
}

/* 全屏模式下的样式 */
.video-element:fullscreen {
  object-fit: contain;
  background: black;
}

.video-element:-webkit-full-screen {
  object-fit: contain;
  background: black;
}

.video-element:-moz-full-screen {
  object-fit: contain;
  background: black;
}

.video-element:-ms-fullscreen {
  object-fit: contain;
  background: black;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .video-player {
    min-height: 250px;
  }
  
  .video-header {
    padding: 0.75rem;
  }
  
  .video-title {
    font-size: 0.8125rem;
  }
  
  .control-btn {
    width: 32px;
    height: 32px;
  }
  
  .video-stats {
    padding: 0.75rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
  }
  
  .stat-label,
  .stat-value {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .video-player {
    min-height: 200px;
  }
  
  .video-header {
    padding: 0.5rem;
  }
  
  .video-title {
    font-size: 0.75rem;
  }
  
  .control-btn {
    width: 28px;
    height: 28px;
  }
  
  .streaming-indicator {
    padding: 0.375rem 0.75rem;
    font-size: 0.6875rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.375rem;
  }
  
  .stat-label {
    font-size: 0.5625rem;
  }
  
  .stat-value {
    font-size: 0.6875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VideoPlayer.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,oEAAoE;EACpE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oEAAoE;EACpE,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* 视频播放器样式 */\n\n.video-player {\n  position: relative;\n  border-radius: 16px;\n  overflow: hidden;\n  background: var(--gray-900);\n  min-height: 300px;\n  animation: fadeIn var(--duration-normal) ease;\n}\n\n.video-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), transparent);\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 10;\n  opacity: 0;\n  transition: opacity var(--duration-normal) ease;\n}\n\n.video-header.visible {\n  opacity: 1;\n}\n\n.video-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.video-title i {\n  color: var(--lemon-400);\n}\n\n.video-controls {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.control-btn {\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--duration-normal) ease;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.control-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.control-btn.active {\n  background: var(--lemon-400);\n  color: var(--gray-900);\n}\n\n.connection-details {\n  position: absolute;\n  top: 60px;\n  right: 1rem;\n  background: rgba(0, 0, 0, 0.9);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 1rem;\n  min-width: 250px;\n  z-index: 15;\n  animation: slideInDown var(--duration-normal) ease;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.detail-row:last-child {\n  margin-bottom: 0;\n  border-bottom: none;\n}\n\n.detail-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.8);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.detail-label i {\n  color: var(--lemon-400);\n  width: 14px;\n}\n\n.detail-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: white;\n}\n\n.status-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status-indicator.success {\n  background: rgba(34, 197, 94, 0.2);\n  color: var(--leaf-400);\n}\n\n.status-indicator.warning {\n  background: rgba(250, 204, 21, 0.2);\n  color: var(--lemon-400);\n}\n\n.status-indicator.error {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.video-element {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: var(--gray-900);\n  min-height: 300px;\n}\n\n.video-overlay {\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 10;\n}\n\n.streaming-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: rgba(34, 197, 94, 0.9);\n  color: white;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.streaming-indicator i {\n  font-size: 0.625rem;\n  color: white;\n}\n\n.video-stats {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);\n  padding: 1rem;\n  backdrop-filter: blur(10px);\n  border-radius: 0 0 16px 16px;\n  opacity: 0;\n  transition: opacity var(--duration-normal) ease;\n}\n\n.video-player:hover .video-stats {\n  opacity: 1;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  text-align: center;\n}\n\n.stat-label {\n  font-size: 0.625rem;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n  margin-bottom: 0.125rem;\n}\n\n.stat-value {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: white;\n  word-break: break-word;\n}\n\n.stat-value.good {\n  color: var(--leaf-400);\n}\n\n.stat-value.warning {\n  color: var(--lemon-400);\n}\n\n.stat-value.error {\n  color: #ef4444;\n}\n\n.local-player {\n  border: 2px solid var(--leaf-400);\n  box-shadow: 0 0 20px rgba(34, 197, 94, 0.3);\n}\n\n.remote-player {\n  border: 2px solid var(--lemon-400);\n  box-shadow: 0 0 20px rgba(250, 204, 21, 0.3);\n}\n\n.pulse {\n  animation: pulse 2s infinite;\n}\n\n/* 全屏模式下的样式 */\n.video-element:fullscreen {\n  object-fit: contain;\n  background: black;\n}\n\n.video-element:-webkit-full-screen {\n  object-fit: contain;\n  background: black;\n}\n\n.video-element:-moz-full-screen {\n  object-fit: contain;\n  background: black;\n}\n\n.video-element:-ms-fullscreen {\n  object-fit: contain;\n  background: black;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .video-player {\n    min-height: 250px;\n  }\n  \n  .video-header {\n    padding: 0.75rem;\n  }\n  \n  .video-title {\n    font-size: 0.8125rem;\n  }\n  \n  .control-btn {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .video-stats {\n    padding: 0.75rem;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.5rem;\n  }\n  \n  .stat-label,\n  .stat-value {\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-player {\n    min-height: 200px;\n  }\n  \n  .video-header {\n    padding: 0.5rem;\n  }\n  \n  .video-title {\n    font-size: 0.75rem;\n  }\n  \n  .control-btn {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .streaming-indicator {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.6875rem;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.375rem;\n  }\n  \n  .stat-label {\n    font-size: 0.5625rem;\n  }\n  \n  .stat-value {\n    font-size: 0.6875rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
